import { Link } from "react-router-dom";

const MenuColumn = ({ title, items, handleClose, variant = "internal" }) => (
  <div>
    {title && (
      <h3 className="mb-3.5 font-poppins text-base font-bold text-default">
        {title}
      </h3>
    )}
    <ul className="space-y-3.5 text-sm">
      {items?.map((menu) => {
        const isExternalLink = menu?.url?.includes("http");
        const showExternalIcon = variant === "external";
        const className =
          "flex items-center justify-between gap-3 border-b border-transparent py-1 font-poppins text-gray transition-all hover:border-hire-line hover:pl-1.5 hover:text-primary";
        const content = (
          <>
            {menu?.title}
            {showExternalIcon ? (
              <span aria-hidden="true">↗</span>
            ) : (
              <b aria-hidden="true">→</b>
            )}
          </>
        );

        return (
          <li key={menu.id}>
            {isExternalLink ? (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={menu?.url}
                className={className}
              >
                {content}
              </a>
            ) : (
              <Link to={menu?.url} onClick={handleClose} className={className}>
                {content}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  </div>
);

export default MenuColumn;
